import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1.5rem;

  &&& tbody td {
    min-width: 0;
  }

  &&& thead th {
    min-width: 0;
  }

  &&& .name-column {
    min-width: 16rem;
  }

  &&& .id-column {
    min-width: 7.5rem;
  }

  &&& .quantity-column {
    min-width: 6.6rem;
  }

  &&& tr {
    transition: background-color 0.1s linear;

    &.invalid {
      transition: background-color 0.1s linear;
      background: ${COLORS.LIGHT_RED};

      &&&:hover td {
        background: ${COLORS.LIGHT_RED} !important;
      }
    }
  }
`;
